import React from 'react'
import { useCommunity, useCommunityText } from 'utils'
import {
  CommunityImage,
  ExternalLink,
  FooterLegalese,
  MultipleLogoBlock,
  RenderedHtml,
} from 'components'

function Footer() {
  const community = useCommunity()
  const communityText = useCommunityText()
  const learnMoreAboutArtlookMessage = communityText(
    'map.footer.learnMoreAboutArtlook'
  )
  const contactMessage = communityText('map.footer.contact')
  const secondaryFooterLogo = community.defaultBranding.secondaryFooterLogo
  const supportEmail = community.partnerSupportEmail || 'info@artlookmap.com'
  const renderFooterLogo =
    secondaryFooterLogo && community.subdomain !== 'alabama'
  const isMichigan = community.subdomain == 'michigan'

  return (
    <footer>
      <div className="footer-block-container">
        <div className="footer-links">
          <h1 className="questions-header">Questions?</h1>
          <ul className="primary-nav">
            <li>
              <ExternalLink
                className="button-secondary"
                href="https://artlookmap.com"
              >
                <RenderedHtml>{learnMoreAboutArtlookMessage}</RenderedHtml>
              </ExternalLink>
            </li>
            <li>
              <ExternalLink
                className="button-secondary"
                href={`mailto:${supportEmail}`}
              >
                {contactMessage}
              </ExternalLink>
            </li>
          </ul>
        </div>
        <div className="footer-links-secondary">
          <FooterLegalese />
        </div>
      </div>
      {isMichigan && (
        <MultipleLogoBlock logos={community.defaultBranding.footerLogos} />
      )}
      {renderFooterLogo && (
        <div className="logo-block">
          <CommunityImage image={secondaryFooterLogo} />
        </div>
      )}
    </footer>
  )
}

export default Footer
